<template>
	<div class="main-content">
		<div class="header">
			<div class="container-fluid">
				<div class="mt-5">
					<div class="card">
						<div class="card-body">
							<nav aria-label="breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item fw-bolder">
										<router-link :to="{ name: 'ListContract' }" style="color: black"> List Contract </router-link>
									</li>
									<li class="breadcrumb-item">Historical Log Contract</li>
								</ol>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="header">
				<div class="mt-5">
					<div class="card">
						<div class="card-header">
							<h3 class="card-header-title">
								Historical Log Contract -
								<span v-if="detailList.status == 'Early Termination'" :class="getStatusClass(detailList.status)">
									Early Terminated
								</span>
								<span v-if="detailList.status == 'Closed'" :class="getStatusClass(detailList.status)"> Closed </span>
								<span v-if="detailList.status == 'On Going'" :class="getStatusClass(detailList.status)"> On Going </span>
								<span v-if="detailList.status == 'Expired Soon'" :class="getStatusClass(detailList.status)">
									Expired Soon
								</span>
								<span v-if="detailList.status == 'Expired'" :class="getStatusClass(detailList.status)"> Expired </span>
								<span v-if="detailList.status == 'Draft'" :class="getStatusClass(detailList.status)"> Draft </span>
								<span v-if="detailList.value_warning" :class="'ml-2 ' + getStatusClass('Value Warning')"> Value Warning </span>
							</h3>
						</div>
						<div class="row card-body">
							<div class="px-2">
								<div class="row gx-3 gy-3">
									<div class="col-12 col-lg-6">
										<div class="card p-3">
											<div class="row gx-3 gy-5">
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-clipboard"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Type of Contract</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.typeContract?.name }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-bookmark"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Name</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.name }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-bookmark"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Number</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.no }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-dollar-sign"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Value</h4>
															<small class="text-body-secondary"
																><span> Rp.{{ convertNumber(detailList?.contract_value) }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-dollar-sign"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Remaining Value</h4>
															<small class="text-body-secondary">
																<span>
																	{{ detailList?.remaining_budget ? `Rp.${convertNumber(detailList.remaining_budget)}` : '-' }}<br />
																</span>
															</small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-home"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Vendor</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.vendor }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-user"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Owner</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.owner?.fullname }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-octagon"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Owner Department</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.owner?.department }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-user"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Co-Owner/PMO</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.co_owner?.fullname }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-octagon"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Co-Owner/PMO Department</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.co_owner?.department }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Start Date</h4>
															<small class="text-body-secondary"
																><span> {{ startDate }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">End Date</h4>
															<small class="text-body-secondary"
																><span> {{ endDate }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Total Duration (Month)</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.total_duration }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-star"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Amendment {{ detailList.amandement }}</h4>
															<small class="text-body-secondary"
																><span>Version {{ detailList.version }}<br /></span
															></small>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-lg-6">
										<div class="card p-3">
											<div class="row gx-3 gy-5">
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Created At</h4>
															<small class="text-body-secondary"
																><span> {{ createdAt }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Created By</h4>
															<small class="text-body-secondary"
																><span> {{ createdBy }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Last Updated At</h4>
															<small class="text-body-secondary"
																><span> {{ updatedAt }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Last Updated By</h4>
															<small class="text-body-secondary"
																><span> {{ updatedBy }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Closed At</h4>
															<small class="text-body-secondary"
																><span> {{ closedDate }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Closed by</h4>
															<small class="text-body-secondary"
																><span>
																	{{ detailList?.activity?.find((x) => x.status === 'Closed')?.user?.fullname || '-' }}
																	<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Terminated At</h4>
															<small class="text-body-secondary"
																><span> {{ terminatedDate }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Terminated by</h4>
															<small class="text-body-secondary"
																><span>
																	{{ detailList?.activity?.find((x) => x.status === 'Early Termination')?.user?.fullname || '-' }}
																	<br /></span
															></small>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="card p-3">
											<h4 class="mb-3 font-weight-bold">Contract Budget</h4>
											<table class="table table-sm table-striped">
												<thead>
													<tr>
														<th scope="col">Year</th>
														<th scope="col">Is Budget Set ?</th>
													</tr>
												</thead>
												<tbody></tbody>
												<tr v-for="(year, index) in detailList.contractYears" :key="index">
													<td>{{ index }}</td>
													<td>
														<i class="fe fe-check text-success" v-if="detailList.contractYears[index]"></i>
														<i class="fe fe-x text-danger" v-else></i>
													</td>
												</tr>
											</table>
										</div>
									</div>
								</div>
							</div>
							<div class="card">
								<div class="row">
									<div class="row col-12">
										<!-- If self point >= 0 -->
										<template>
											<div class="p-4">
												<div class="col-12 col-xl">
													<h4><strong>Scope Of Work</strong></h4>
													<p class="small mt-2">
														{{ detailList?.scope_of_work || 'No scope of work available' }}
													</p>
												</div>
											</div>
										</template>
									</div>
									<div class="row col-12 col-lg-2 col-sm"></div>
								</div>
							</div>
							<div class="card">
								<div class="card-header">
									<div class="card-header-title">Supporting File</div>
								</div>
								<div class="card-body">
									<div class="row">
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">ToR</label>
												<p>
													<a :href="detailList?.upload_tor?.[0]?.file" target="_blank">{{
														detailList?.upload_tor?.[0]?.file ? 'File ToR.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">BoQ</label>
												<p>
													<a :href="detailList?.upload_boq?.[0]?.file" target="_blank">{{
														detailList?.upload_boq?.[0]?.file ? 'File BoQ.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">OE</label>
												<p>
													<a :href="detailList?.upload_oe?.[0]?.file" target="_blank">{{
														detailList?.upload_oe?.[0]?.file ? 'File OE.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">NoA/SPP</label>
												<p>
													<a :href="detailList?.upload_noa_spp?.[0]?.file" target="_blank">{{
														detailList?.upload_noa_spp?.[0]?.file ? 'File NoA/SPP.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">Contract Fully Signed</label>
												<p>
													<a :href="detailList?.upload_fs?.[0]?.file" target="_blank">{{
														detailList?.upload_fs?.[0]?.file ? 'File Contract Fully Signed.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">BAPP</label>
												<p>
													<a :href="detailList?.upload_bapp?.[0]?.file" target="_blank">{{
														detailList?.upload_bapp?.[0]?.file ? 'File BAPP.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3" v-if="detailList.files && detailList.files.length > 0">
											<div class="form-group">
												<label class="font-weight-bold">Others</label>
												<p v-if="detailList.files">
													<a :href="detailList?.files?.[0]?.file" target="_blank">{{
														detailList?.files?.[0]?.file ? 'File Others.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="card" v-if="detailList.status === 'Closed'">
								<div class="card-header">
									<div class="card-header-title">Close Information</div>
								</div>
								<div class="card-body row">
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label class="font-weight-bold">Closed At</label>
											<p>{{ closedDate }}</p>
										</div>
									</div>
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label class="font-weight-bold">Closed By</label>
											<p>
												{{ detailList?.activity?.find((x) => x.status === 'Closed')?.user?.fullname || 'System' }}
											</p>
										</div>
									</div>
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label class="font-weight-bold">Closing Report</label>
											<p v-if="detailList.closing_report && detailList.closing_report.length > 0">
												<a :href="detailList?.closing_report?.[0]?.file" target="_blank">{{
													detailList?.closing_report?.[0]?.file ? 'File Closing Report.pdf' : '-'
												}}</a>
											</p>
											<p v-else>No file available</p>
										</div>
									</div>
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label class="font-weight-bold">BA Retention</label>
											<p v-if="detailList.ba_retention && detailList.ba_retention.length > 0">
												<a :href="detailList?.ba_retention?.[0]?.file" target="_blank">File BA Retention.pdf</a>
											</p>
											<p v-else>No file available</p>
										</div>
									</div>
									<div class="col-12">
										<label class="font-weight-bold">Note</label>
										<p>
											{{ detailList?.activity?.find((x) => x.status === 'Closed')?.notes || '-' }}
										</p>
									</div>
								</div>
							</div>
							<div class="card" v-if="detailList.status === 'Early Termination'">
								<div class="card-header">
									<div class="card-header-title">Termination Information</div>
								</div>
								<div class="card-body row">
									<div class="col-12 col-lg-4">
										<div class="form-group">
											<label class="font-weight-bold">Terminated At</label>
											<p>{{ terminatedDate }}</p>
										</div>
									</div>
									<div class="col-12 col-lg-4">
										<div class="form-group">
											<label class="font-weight-bold">Terminated By</label>
											<p>
												{{ detailList?.activity?.find((x) => x.status === 'Early Termination')?.user?.fullname || '-' }}
											</p>
										</div>
									</div>
									<div class="col-12 col-lg-4">
										<div class="form-group">
											<label class="font-weight-bold">Evidence</label>
											<p v-if="detailList.upload_evidence && detailList.upload_evidence.length > 0">
												<a :href="detailList?.upload_evidence?.[0]?.file" target="_blank">{{
													detailList?.upload_evidence?.[0]?.file ? 'File Evidence.pdf' : '-'
												}}</a>
											</p>
											<p v-else>No file available</p>
										</div>
									</div>
									<div class="col-12">
										<label class="font-weight-bold">Note</label>
										<p>
											{{ detailList?.activity?.find((x) => x.status === 'Early Termination')?.notes || '-' }}
										</p>
									</div>
								</div>
							</div>
						</div>

						<div class="col-12">
							<div class="font-weight-bold text-center mb-2">Historical Log</div>
							<div v-if="historicalLog && Object.keys(historicalLog).length > 0">
								<vsa-list style="max-width: 100% !important">
									<vsa-item v-for="(version, amandementName) in historicalLog" :key="amandementName">
										<vsa-heading>{{ amandementName }}</vsa-heading>
										<vsa-icon>
											<span class="isOpen fe fe-chevron-down"></span>
											<span class="isClose fe fe-chevron-up"></span>
										</vsa-icon>
										<vsa-content>
											<vsa-list style="max-width: 100% !important">
												<vsa-item v-for="(item, idx) in version" :key="idx">
													<vsa-heading style="text-align: center !important">
														{{ 'Version ' + item.version }}
													</vsa-heading>
													<vsa-icon> &nbsp; </vsa-icon>
													<vsa-content>
														<label
															>Update By: <b>{{ item.update_by || 'N/A' }}</b></label
														><br />
														<label
															>Update At: <b>{{ item.update_at || 'N/A' }}</b></label
														>

														<template v-if="hasAnyChangesInVersion(item)">
															<div v-for="(item_change, key) in item.changes" :key="key">
																<!-- If Budget GL -->
																<div v-if="item_change.label === 'list_budget_gl'">
																	<div v-for="(oldItem, index) in item_change.old_value" :key="index" class="mb-3">
																		<template v-if="Object.keys(getChangedValues(oldItem, item_change.new_value[index])).length > 0">
																			<div class="d-flex align-items-center mb-3">
																				<!-- Old Value -->
																				<div class="bg-light rounded p-3 col-lg-4">
																					<span class="small bg-danger text-white px-2 py-1 mb-2 rounded d-inline-block">Old Value</span>
																					<div class="fw-semibold">List Budget GL</div>
																					<div class="fw-semibold">
																						{{ `Budget Task Name: ${oldItem?.budget_task_name || 'N/A'}` }}
																					</div>
																					<div v-for="(value, key) in getChangedValues(oldItem, item_change.new_value[index])" :key="key">
																						<div class="fw-bold">
																							{{ key | toSpacedText }}:
																							<span class="text-danger">{{
																								key === 'remaining_budget' ? 'Rp' + convertNumber(value.old) : value.old || 'N/A'
																							}}</span>
																						</div>
																					</div>
																				</div>
																				<!-- arrow -->
																				<div class="px-3">
																					<svg
																						xmlns="http://www.w3.org/2000/svg"
																						width="24"
																						height="24"
																						viewBox="0 0 24 24"
																						fill="none"
																						stroke="currentColor"
																						stroke-width="2"
																						stroke-linecap="round"
																						stroke-linejoin="round"
																					>
																						<line x1="5" y1="12" x2="19" y2="12"></line>
																						<polyline points="12 5 19 12 12 19"></polyline>
																					</svg>
																				</div>

																				<!-- New Value -->
																				<div class="bg-light rounded p-3 col-lg-4">
																					<span class="small bg-success text-black px-2 py-1 mb-2 rounded d-inline-block">New Value</span>
																					<div class="fw-semibold">List Budget GL</div>
																					<div class="fw-semibold">
																						{{ `Budget Task Name: ${item_change.new_value[index]?.budget_task_name || 'N/A'}` }}
																					</div>
																					<div v-for="(value, key) in getChangedValues(oldItem, item_change.new_value[index])" :key="key">
																						<div class="fw-bold">
																							{{ key | toSpacedText }}:
																							<span class="text-success">{{
																								key === 'remaining_budget' ? 'Rp' + convertNumber(value.new) : value.new || 'N/A'
																							}}</span>
																						</div>
																					</div>
																				</div>
																			</div>
																		</template>
																	</div>
																</div>
																<!-- TOP -->
																<div v-else-if="item_change.label === 'term_of_payments'">
																	<div class="d-flex align-items-center mb-3">
																		<!-- Old Value -->
																		<div class="bg-light rounded p-3 col-lg-4">
																			<span class="small bg-danger text-white px-2 py-1 mb-2 rounded d-inline-block">Old Value</span>

																			<!-- Fixed Assignment Section -->
																			<div class="mb-3">
																				<div class="fw-bold">Fixed Assignment</div>
																				<div>
																					Percentage:
																					{{ item_change.old_value.fixed_assignment.percentage }}%
																				</div>
																				<div>
																					Amount: Rp
																					{{ item_change.old_value.fixed_assignment.amount }}
																				</div>

																				<div
																					class="ml-3 mb-1"
																					v-for="(fa_item, fa_index) in item_change.old_value.fixed_assignment.contract_items"
																					:key="'old_fa_' + fa_index"
																				>
																					<div class="fw-semibold">Contract Item: {{ fa_item.contract_item }}</div>
																					<div
																						class="ml-3 mb-1"
																						v-for="(term, term_index) in fa_item.terms"
																						:key="'old_fa_term_' + term_index"
																					>
																						<div>Term: {{ term.term }}</div>
																						<div>
																							Percentage:
																							<span class="text-danger">{{ term.percentage }}%</span>
																						</div>
																						<div>
																							Amount:
																							<span class="text-danger">Rp{{ term.amount }}</span>
																						</div>
																						<div>Description: {{ term.description }}</div>
																					</div>
																					<div class="fw-bold">
																						Total Percentage Item:
																						<span class="text-danger">{{ fa_item.percentage_item }}%</span>
																					</div>
																					<div class="fw-bold">
																						Amount Item: Rp
																						<span class="text-danger">{{ fa_item.amount_item }}</span>
																					</div>
																					<div v-for="item in items" :key="item.id">
																						{{ item }}
																					</div>
																				</div>
																			</div>

																			<!-- Provision Section -->
																			<div class="mb-3" v-if="item_change.old_value.provision">
																				<div class="fw-bold">Provision</div>
																				<div>
																					Percentage:
																					{{ item_change.old_value.provision.percentage }}%
																				</div>
																				<div>Amount: {{ item_change.old_value.provision.amount }}</div>

																				<div
																					class="ml-3 mb-1"
																					v-for="(fa_item, fa_index) in item_change.old_value.provision.contract_items"
																					:key="'old_fa_' + fa_index"
																				>
																					<div class="fw-semibold">Contract Item: {{ fa_item.contract_item }}</div>
																					<div
																						class="ml-3 mb-1"
																						v-for="(term, term_index) in fa_item.terms"
																						:key="'old_fa_term_' + term_index"
																					>
																						<div>Term: {{ term.term }}</div>
																						<div>
																							Percentage:
																							<span class="text-danger">{{ term.percentage }}%</span>
																						</div>
																						<div>
																							Amount:
																							<span class="text-danger">Rp{{ term.amount }}</span>
																						</div>
																						<div>Description: {{ term.description }}</div>
																					</div>
																					<div class="fw-bold">
																						Total Percentage Item:
																						<span class="text-danger">{{ fa_item.percentage_item }}%</span>
																					</div>
																					<div class="fw-bold">
																						Amount Item:
																						<span class="text-danger">Rp {{ fa_item.amount_item }}</span>
																					</div>
																					<div v-for="item in items" :key="item.id">
																						{{ item }}
																					</div>
																				</div>
																			</div>
																		</div>
																		<!-- arrow -->
																		<div class="px-3">
																			<svg
																				xmlns="http://www.w3.org/2000/svg"
																				width="24"
																				height="24"
																				viewBox="0 0 24 24"
																				fill="none"
																				stroke="currentColor"
																				stroke-width="2"
																				stroke-linecap="round"
																				stroke-linejoin="round"
																			>
																				<line x1="5" y1="12" x2="19" y2="12"></line>
																				<polyline points="12 5 19 12 12 19"></polyline>
																			</svg>
																		</div>

																		<!-- New Value -->
																		<div class="bg-light rounded p-3 col-lg-4">
																			<span class="small bg-success text-black px-2 py-1 mb-2 rounded d-inline-block">New Value</span>

																			<!-- Fixed Assignment Section -->
																			<div class="mb-3">
																				<div class="fw-bold">Fixed Assignment</div>
																				<div>
																					Percentage:
																					{{ item_change.new_value.fixed_assignment.percentage }}%
																				</div>
																				<div>
																					Amount: Rp
																					{{ item_change.new_value.fixed_assignment.amount }}
																				</div>

																				<div
																					class="ml-3 mb-1"
																					v-for="(fa_item, fa_index) in item_change.new_value.fixed_assignment.contract_items"
																					:key="'old_fa_' + fa_index"
																				>
																					<div class="fw-semibold">Contract Item: {{ fa_item.contract_item }}</div>
																					<div
																						class="ml-3 mb-1"
																						v-for="(term, term_index) in fa_item.terms"
																						:key="'old_fa_term_' + term_index"
																					>
																						<div>Term: {{ term.term }}</div>
																						<div>
																							Percentage:
																							<span class="text-danger">{{ term.percentage }}%</span>
																						</div>
																						<div>
																							Amount:
																							<span class="text-danger">Rp{{ term.amount }}</span>
																						</div>
																						<div>Description: {{ term.description }}</div>
																					</div>
																					<div class="fw-bold">
																						Total Percentage Item:
																						<span class="text-danger">{{ fa_item.percentage_item }}%</span>
																					</div>
																					<div class="fw-bold">
																						Amount Item:
																						<span class="text-danger">Rp {{ fa_item.amount_item }}</span>
																					</div>
																					<div v-for="item in items" :key="item.id">
																						{{ item }}
																					</div>
																				</div>
																			</div>

																			<!-- Provision Section -->
																			<div class="mb-3" v-if="item_change.new_value.provision">
																				<div class="fw-bold">Provision</div>
																				<div>
																					Percentage:
																					{{ item_change.new_value.provision.percentage }}%
																				</div>
																				<div>Amount: {{ item_change.new_value.provision.amount }}</div>

																				<div
																					class="ml-3 mb-1"
																					v-for="(fa_item, fa_index) in item_change.new_value.provision.contract_items"
																					:key="'old_fa_' + fa_index"
																				>
																					<div class="fw-semibold">Contract Item: {{ fa_item.contract_item }}</div>
																					<div
																						class="ml-3 mb-1"
																						v-for="(term, term_index) in fa_item.terms"
																						:key="'old_fa_term_' + term_index"
																					>
																						<div>Term: {{ term.term }}</div>
																						<div>
																							Percentage:
																							<span class="text-danger">{{ term.percentage }}%</span>
																						</div>
																						<div>
																							Amount:
																							<span class="text-danger">Rp{{ term.amount }}</span>
																						</div>
																						<div>Description: {{ term.description }}</div>
																					</div>
																					<div class="fw-bold">
																						Total Percentage Item:
																						<span class="text-danger">{{ fa_item.percentage_item }}%</span>
																					</div>
																					<div class="fw-bold">
																						Amount Item:
																						<span class="text-danger">Rp {{ fa_item.amount_item }}</span>
																					</div>
																					<div v-for="item in items" :key="item.id">
																						{{ item }}
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<!-- Contract Duration Detail -->
																<div
																	class="d-flex align-items-center mb-3"
																	v-else-if="item_change.label === 'contract_duration_detail'"
																>
																	<!-- Old Value -->
																	<div class="bg-light rounded p-3 col-lg-4 gap-6">
																		<span class="small bg-danger text-white px-2 py-1 mb-2 rounded d-inline-block">Old Value</span>

																		<div class="mb-3">
																			<div class="fw-semibold">
																				{{ item_change.label | toSpacedText }}
																			</div>

																			<div
																				v-for="(detail, detailIndex) in item_change.old_value.details"
																				:key="'old_detail_' + detailIndex"
																			>
																				<div class="fw-semibold">Detail Name: {{ detail.detail_name }}</div>

																				<div v-for="(item, itemIndex) in detail?.items" :key="'old_item_' + itemIndex">
																					<div>Item Name: {{ item.item_name }}</div>
																					<div class="fw-bold">
																						Work Duration:
																						<span class="text-danger">{{ item.work_duration }}</span>
																					</div>
																					<div>Description: {{ item.description }}</div>
																				</div>
																			</div>
																		</div>
																	</div>

																	<!-- arrow -->
																	<div class="px-3">
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="24"
																			height="24"
																			viewBox="0 0 24 24"
																			fill="none"
																			stroke="currentColor"
																			stroke-width="2"
																			stroke-linecap="round"
																			stroke-linejoin="round"
																		>
																			<line x1="5" y1="12" x2="19" y2="12"></line>
																			<polyline points="12 5 19 12 12 19"></polyline>
																		</svg>
																	</div>

																	<!-- New Value -->
																	<div class="bg-light rounded p-3 col-lg-4 gap-6">
																		<span class="small bg-success text-black px-2 py-1 mb-2 rounded d-inline-block">New Value</span>

																		<div class="mb-3">
																			<div class="fw-semibold">
																				{{ item_change.label | toSpacedText }}
																			</div>

																			<div
																				v-for="(detail, detailIndex) in item_change.new_value.details"
																				:key="'new_detail_' + detailIndex"
																			>
																				<div class="fw-semibold">Detail Name: {{ detail.detail_name }}</div>

																				<div v-for="(item, itemIndex) in detail?.items" :key="'new_item_' + itemIndex">
																					<div>Item Name: {{ item.item_name }}</div>
																					<div class="fw-bold">
																						Work Duration:
																						<span class="text-success">{{ item.work_duration }}</span>
																					</div>
																					<div>Description: {{ item.description }}</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<!-- Budget -->
																<div
																	class="d-flex align-items-center mb-3"
																	v-else-if="['budget_plan_id', 'budget_gl_id', 'budget_task_id'].includes(item_change.label)"
																>
																	<!-- Old Value -->
																	<div class="bg-light rounded p-3 col-lg-4 gap-6">
																		<span class="small bg-danger text-white px-2 py-1 mb-2 rounded d-inline-block">Old Value</span>

																		<div class="mb-3">
																			<div class="fw-semibold">
																				{{ item_change.label | toSpacedText }}
																			</div>
																			<ul class="list-unstyled mb-0">
																				<li
																					v-for="(item, index) in getFilteredBudgetChanges(item_change).old"
																					:key="'old-' + index"
																					class="d-flex align-items-center mb-2 px-2 py-3 bg-white rounded border-start border-3"
																					:class="item.status === 'deleted' ? 'border-warning' : 'border-danger'"
																				>
																					<div class="flex-grow-1">
																						<small class="text-muted me-1">#{{ item.originalIndex + 1 }}</small>
																						<span v-if="item.status === 'deleted'" class="badge bg-warning text-dark ms-2">DELETED</span>
																						<span v-else-if="item.status === 'changed'" class="badge bg-danger text-white ms-2">CHANGED</span>
																						<br />
																						<p class="mb-0 fw-bold">
																							{{ item.value || 'N/A' }}
																						</p>
																					</div>
																				</li>
																			</ul>
																		</div>
																	</div>

																	<!-- arrow -->
																	<div class="px-3">
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="24"
																			height="24"
																			viewBox="0 0 24 24"
																			fill="none"
																			stroke="currentColor"
																			stroke-width="2"
																			stroke-linecap="round"
																			stroke-linejoin="round"
																		>
																			<line x1="5" y1="12" x2="19" y2="12"></line>
																			<polyline points="12 5 19 12 12 19"></polyline>
																		</svg>
																	</div>

																	<!-- New Value -->
																	<div class="bg-light rounded p-3 col-lg-4 gap-6">
																		<span class="small bg-success text-black px-2 py-1 mb-2 rounded d-inline-block">New Value</span>

																		<div class="mb-3">
																			<div class="fw-semibold">
																				{{ item_change.label | toSpacedText }}
																			</div>
																			<ul class="list-unstyled mb-0">
																				<li
																					v-for="(item, index) in getFilteredBudgetChanges(item_change).new"
																					:key="'new-' + index"
																					class="d-flex align-items-center mb-2 px-2 py-3 bg-white rounded border-start border-3"
																					:class="
																						item.status === 'deleted'
																							? 'border-warning'
																							: item.status === 'added'
																							? 'border-info'
																							: 'border-success'
																					"
																				>
																					<div class="flex-grow-1">
																						<small class="text-muted me-1">#{{ item.originalIndex + 1 }}</small>
																						<span v-if="item.status === 'deleted'" class="badge bg-secondary text-white ms-2">REMOVED</span>
																						<span v-else-if="item.status === 'added'" class="badge bg-info text-white ms-2">ADDED</span>
																						<span v-else-if="item.status === 'changed'" class="badge bg-success text-white ms-2"
																							>UPDATED</span
																						>
																						<br />
																						<p class="mb-0 fw-bold" :class="item.value === 'N/A' ? 'text-muted' : ''">
																							{{ item.value || 'N/A' }}
																						</p>
																					</div>
																				</li>
																			</ul>
																		</div>
																	</div>
																</div>
																<!-- OA Number -->
																<div class="d-flex align-items-center mb-3" v-else-if="item_change.label === 'oa_number'">
																	<!-- Old Value -->
																	<div class="bg-light rounded p-3 col-lg-4 gap-6">
																		<span class="small bg-danger text-white px-2 py-1 mb-2 rounded d-inline-block">Old Value</span>

																		<div class="mb-3">
																			<div class="fw-semibold">
																				{{ item_change.label | toSpacedText }}
																			</div>
																			<ul class="list-unstyled mb-0">
																				<li
																					v-for="(item, index) in getFilteredOaChanges(item_change).old"
																					:key="'old-' + index"
																					class="d-flex align-items-center mb-2 px-2 py-3 bg-white rounded border-start border-3"
																					:class="item.status === 'deleted' ? 'border-warning' : 'border-danger'"
																				>
																					<div class="flex-grow-1">
																						<small class="text-muted me-1">#{{ item.originalIndex + 1 }}</small>
																						<span v-if="item.status === 'deleted'" class="badge bg-warning text-dark ms-2">DELETED</span>
																						<span v-else-if="item.status === 'changed'" class="badge bg-danger text-white ms-2">CHANGED</span>
																						<br />
																						<p class="mb-0 fw-bold">Number: {{ item.oa_number }}</p>
																					</div>
																				</li>
																			</ul>
																		</div>
																	</div>

																	<!-- arrow -->
																	<div class="px-3">
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="24"
																			height="24"
																			viewBox="0 0 24 24"
																			fill="none"
																			stroke="currentColor"
																			stroke-width="2"
																			stroke-linecap="round"
																			stroke-linejoin="round"
																		>
																			<line x1="5" y1="12" x2="19" y2="12"></line>
																			<polyline points="12 5 19 12 12 19"></polyline>
																		</svg>
																	</div>

																	<!-- New Value -->
																	<div class="bg-light rounded p-3 col-lg-4 gap-6">
																		<span class="small bg-success text-black px-2 py-1 mb-2 rounded d-inline-block">New Value</span>

																		<div class="mb-3">
																			<div class="fw-semibold">
																				{{ item_change.label | toSpacedText }}
																			</div>
																			<ul class="list-unstyled mb-0">
																				<li
																					v-for="(item, index) in getFilteredOaChanges(item_change).new"
																					:key="'new-' + index"
																					class="d-flex align-items-center mb-2 px-2 py-3 bg-white rounded border-start border-3"
																					:class="
																						item.status === 'deleted'
																							? 'border-warning'
																							: item.status === 'added'
																							? 'border-info'
																							: 'border-success'
																					"
																				>
																					<div class="flex-grow-1">
																						<small class="text-muted me-1">#{{ item.originalIndex + 1 }}</small>
																						<span v-if="item.status === 'deleted'" class="badge bg-secondary text-white ms-2">REMOVED</span>
																						<span v-else-if="item.status === 'added'" class="badge bg-info text-white ms-2">ADDED</span>
																						<span v-else-if="item.status === 'changed'" class="badge bg-success text-white ms-2"
																							>UPDATED</span
																						>
																						<br />
																						<p class="mb-0 fw-bold" :class="item.oa_number === 'N/A' ? 'text-muted' : ''">
																							Number: {{ item.oa_number }}
																						</p>
																					</div>
																				</li>
																			</ul>
																		</div>
																	</div>
																</div>
																<!-- ELSE -->
																<div v-else class="d-flex align-items-center mb-3">
																	<div class="bg-light rounded p-3 col-lg-4 gap-6">
																		<span class="small bg-danger text-white px-2 py-1 mb-2 rounded d-inline-block">Old Value</span>
																		<div class="mb-2" v-if="item_change.label == 'upload_fs'">
																			{{ 'upload_contract' | toSpacedText }}
																		</div>
																		<div class="mb-2" v-else>{{ item_change.label | toSpacedText }}</div>
																		<div class="fw-bold">
																			<template v-if="item_change.label === 'contract_value'">
																				Rp{{ convertNumber(item_change.old_value) }}
																			</template>
																			<template v-else-if="item_change.label.startsWith('upload') || item_change.label == 'files'">
																				<a
																					v-if="getChangeValue(item_change.old_value, item_change.label) !== 'N/A'"
																					:href="`${documentPath}/
																				${getChangeValue(item_change.old_value, item_change.label)}`"
																					target="_blank"
																				>
																					{{ getChangeValue(item_change.old_value, item_change.label) }}
																				</a>
																				<span v-else class="text-muted">{{
																					getChangeValue(item_change.old_value, item_change.label)
																				}}</span>
																			</template>
																			<template v-else>
																				{{ getChangeValue(item_change.old_value, item_change.label) }}
																			</template>
																		</div>
																	</div>
																	<div class="px-3">
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="24"
																			height="24"
																			viewBox="0 0 24 24"
																			fill="none"
																			stroke="currentColor"
																			stroke-width="2"
																			stroke-linecap="round"
																			stroke-linejoin="round"
																		>
																			<line x1="5" y1="12" x2="19" y2="12"></line>
																			<polyline points="12 5 19 12 12 19"></polyline>
																		</svg>
																	</div>
																	<div class="bg-light rounded p-3 col-lg-4 gap-6">
																		<span class="small bg-success text-black px-2 py-1 mb-2 rounded d-inline-block">New Value</span>
																		<div class="mb-2" v-if="item_change.label == 'upload_fs'">
																			{{ 'upload_contract' | toSpacedText }}
																		</div>
																		<div class="mb-2" v-else>{{ item_change.label | toSpacedText }}</div>
																		<div class="fw-bold">
																			<template v-if="item_change.label === 'contract_value'">
																				Rp{{ convertNumber(item_change.new_value) }}
																			</template>
																			<template v-else-if="item_change.label.startsWith('upload') || item_change.label == 'files'">
																				<a
																					v-if="getChangeValue(item_change.new_value, item_change.label) !== 'N/A'"
																					:href="`${documentPath}/
																				${getChangeValue(item_change.new_value, item_change.label)}`"
																					target="_blank"
																				>
																					{{ getChangeValue(item_change.new_value, item_change.label) }}
																				</a>
																				<span v-else class="text-muted">{{
																					getChangeValue(item_change.new_value, item_change.label)
																				}}</span>
																			</template>
																			<template v-else>
																				{{ getChangeValue(item_change.new_value, item_change.label) }}
																			</template>
																		</div>
																	</div>
																</div>
															</div>
														</template>

														<template v-else>
															<div class="alert bg-primary-soft fade show text-center" role="alert">No changes.</div>
														</template>
													</vsa-content>
												</vsa-item>
											</vsa-list>
										</vsa-content>
									</vsa-item>
								</vsa-list>
							</div>
							<div v-else>
								<div class="alert alert-primary alert-dismissible fade show m-3 text-center" role="alert">
									There is no history or no changes for this contract
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { indonesianCalendar } from '@/utils/common';
	import { VsaList, VsaItem, VsaHeading, VsaContent, VsaIcon } from 'vue-simple-accordion';

	export default {
		name: 'historicalLogContract',
		components: {
			VsaList,
			VsaItem,
			VsaHeading,
			VsaContent,
			VsaIcon,
		},
		computed: {
			detailList() {
				// console.log("detailList", this.$store.getters["listContract/detail"]);
				return this.$store.getters['listContract/historical'];
			},
			closedDate() {
				return indonesianCalendar(this.detailList?.activity?.find((x) => x.status === 'Closed')?.created_at) || '-';
			},
			terminatedDate() {
				return (
					indonesianCalendar(this.detailList?.activity?.find((x) => x.status === 'Early Termination')?.created_at) || '-'
				);
			},
			startDate() {
				return indonesianCalendar(this.detailList?.start_date) || '-';
			},
			endDate() {
				return indonesianCalendar(this.detailList?.end_date) || '-';
			},
			createdAt() {
				return indonesianCalendar(this.detailList?.created_at) || '-';
			},
			createdBy() {
				return this.detailList?.user?.fullname || 'System';
			},
			updatedAt() {
				return indonesianCalendar(this.detailList.lastUpdate?.created_at) || '-';
			},
			updatedBy() {
				return this.detailList.lastUpdate?.user?.fullname || '-';
			},
			documentPath() {
				const date = new Date(this.detailList?.created_at);
				const year = date.getFullYear();
				const base_url = process.env.VUE_APP_DOCUMENT_URL || process.env.VUE_APP_API_URL.slice(0, -4) + '/document';
				const contractId = `${year}/Contract${year}-${this.detailList?.parent_contract_id || this.detailList?.id}`;
				return `${base_url}/${contractId}`;
			},
		},
		data() {
			return {
				activeAccordions: [],
				logsAmandemen: [
					{
						id: 1,
						updatedAt: '2023-01-01',
						amandemen: 1,
						updatedBy: 'Admin',
						version: 2,
						startDateOld: '02 Jun 2023',
						startDateNew: '30 Jun 2023',
						endDateOld: '02 Des 2024',
						endDateNew: '30 Des 2024',
						totalDurationOld: '18',
						totalDurationNew: '18',
					},
					{
						id: 2,
						updatedAt: '2023-01-02',
						amandemen: 2,
						updatedBy: 'Editor',
						version: 2,
						startDateOld: '02 Jun 2023',
						startDateNew: '30 Jun 2023',
						endDateOld: '02 Des 2024',
						endDateNew: '30 Des 2024',
						totalDurationOld: '18',
						totalDurationNew: '18',
					},
					{
						id: 3,
						updatedAt: '2023-01-03',
						amandemen: 3,
						updatedBy: 'Reviewer',
						version: 2,
						startDateOld: '02 Jun 2023',
						startDateNew: '30 Jun 2023',
						endDateOld: '02 Des 2024',
						endDateNew: '30 Des 2024',
						totalDurationOld: '18',
						totalDurationNew: '18',
					},
				],
				logsVersioning: [
					{
						id: 4,
						updatedAt: '2023-01-01',
						version: 1,
						updatedBy: 'Admin',
						contractNameOld: 'Contract Name',
						contractNameNew: 'Contract Name 1',
						vendorOld: 'Vendor 2',
						vendorNew: 'Vendor 3',
					},
					{
						id: 5,
						updatedAt: '2023-01-02',
						version: 2,
						updatedBy: 'Editor',
						contractNameOld: 'Contract Name',
						contractNameNew: 'Contract Name 1',
						vendorOld: 'Vendor 2',
						vendorNew: 'Vendor 3',
					},
					{
						id: 6,
						updatedAt: '2023-01-03',
						version: 3,
						updatedBy: 'Reviewer',
						contractNameOld: 'Contract Name',
						contractNameNew: 'Contract Name 1',
						vendorOld: 'Vendor 2',
						vendorNew: 'Vendor 3',
					},
				],
				items: [],
				historicalLog: {},
			};
		},
		filters: {
			toSpacedText(value) {
				if (!value) return 'N/A';
				return value
					.split('_')
					.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
					.join(' ');
			},
		},
		async mounted() {
			await this.getList();
			this.historicalLog = this.detailList?.historical;
		},
		methods: {
			getChangedValues(oldItem, newItem) {
				let changes = {};
				if (!oldItem || !newItem) return changes;

				Object.keys(oldItem).forEach((key) => {
					if (key === 'oa_number' && newItem[key] === undefined) {
						return;
					}

					if (oldItem[key] !== newItem[key]) {
						changes[key] = { old: oldItem[key], new: newItem[key] };
					}
				});

				return changes;
			},
			// Method untuk convert string comma-separated menjadi array
			convertStringToArray(value) {
				if (!value) return [];
				if (Array.isArray(value)) return value;

				// Check if it's a comma-separated string
				if (value.includes(', ')) {
					return value.split(', ').map((item, index) => ({
						no: index + 1,
						value: item.trim(),
					}));
				} else {
					// Single value, treat as single item array
					return [
						{
							no: 1,
							value: value.trim(),
						},
					];
				}
			},

			// Method untuk filter budget changes
			getFilteredBudgetChanges(itemChange) {
				// Convert string values to array format for budget fields
				const oldArray = this.convertStringToArray(itemChange.old_value || '');
				const newArray = this.convertStringToArray(itemChange.new_value || '');

				// Use the generic getChangedArrayItems with 'value' as the comparison key
				const result = this.getChangedArrayItems(oldArray, newArray, 'value');

				return result;
			},

			// Method untuk filter budget changes
			// getFilteredBudgetChanges(itemChange) {
			// 	// Convert string values to array format for budget fields
			// 	const oldArray = this.convertStringToArray(itemChange.old_value || '');
			// 	const newArray = this.convertStringToArray(itemChange.new_value || '');

			// 	// Use the generic getChangedArrayItems with 'value' as the comparison key
			// 	return this.getChangedArrayItems(oldArray, newArray, 'value');
			// },
			hasChanges(oldItem, newItem) {
				return Object.keys(this.getChangedValues(oldItem, newItem)).length > 0;
			},
			hasAnyChangesInVersion(versionItem) {
				if (!versionItem.changes) return false;

				return versionItem.changes.some((change) => {
					// Handle oa_number array
					if (change.label === 'oa_number' && Array.isArray(change.old_value) && Array.isArray(change.new_value)) {
						const changedItems = this.getChangedArrayItems(change.old_value, change.new_value);
						return changedItems.old.length > 0;
					}

					// For list_budget_gl, check if any items actually changed
					if (change.label === 'list_budget_gl') {
						if (!change.old_value || !change.new_value) return true;

						return change.old_value.some((oldItem, index) => {
							const newItem = change.new_value[index];
							return this.hasChanges(oldItem, newItem);
						});
					}

					return change.old_value !== change.new_value;
				});
			},
			getChangeValue(value, type) {
				const fileTypes = ['files', 'upload_tor', 'upload_noa_spp', 'upload_boq', 'upload_oe', 'upload_fs', 'upload_bapp'];
				if (fileTypes.includes(type) && Array.isArray(value)) {
					return value.length > 0 ? value[0] : 'N/A'; // Ambil indeks pertama jika array tidak kosong
				}
				return value || 'N/A';
			},
			getChangedArrayItems(oldArray, newArray, compareKey = 'oa_number') {
				const changedOld = [];
				const changedNew = [];
				const maxLength = Math.max(oldArray.length, newArray.length);

				for (let i = 0; i < maxLength; i++) {
					const oldItem = oldArray[i];
					const newItem = newArray[i];

					if (oldItem && newItem) {
						// Item exists in both - check if changed
						const oldValue = compareKey === 'value' ? oldItem.value : oldItem[compareKey];
						const newValue = compareKey === 'value' ? newItem.value : newItem[compareKey];

						if (String(oldValue || '') !== String(newValue || '')) {
							changedOld.push({
								...oldItem,
								originalIndex: i,
								status: 'changed',
							});
							changedNew.push({
								...newItem,
								originalIndex: i,
								status: 'changed',
							});
						}
					} else if (!oldItem && newItem) {
						// Item added (exists in new but not old)
						const naItem = {
							no: i + 1,
							originalIndex: i,
							status: 'added',
						};

						// Set the appropriate N/A value based on compare key
						if (compareKey === 'value') {
							naItem.value = 'N/A';
						} else {
							naItem[compareKey] = 'N/A';
						}

						changedOld.push(naItem);
						changedNew.push({
							...newItem,
							originalIndex: i,
							status: 'added',
						});
					} else if (oldItem && !newItem) {
						// Item deleted (exists in old but not new)
						changedOld.push({
							...oldItem,
							originalIndex: i,
							status: 'deleted',
						});

						const naItem = {
							no: i + 1,
							originalIndex: i,
							status: 'deleted',
						};

						if (compareKey === 'value') {
							naItem.value = 'N/A';
						} else {
							naItem[compareKey] = 'N/A';
						}

						changedNew.push(naItem);
					}
				}

				return { old: changedOld, new: changedNew };
			},
			getFilteredOaChanges(itemChange) {
				return this.getChangedArrayItems(itemChange.old_value || [], itemChange.new_value || []);
			},
			toggleAccordion(id) {
				const index = this.activeAccordions.indexOf(id);
				if (index === -1) {
					this.activeAccordions.push(id);
				} else {
					this.activeAccordions.splice(index, 1);
				}
			},
			convertNumber(dat) {
				if (dat) {
					return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
				} else if (dat === 0) {
					return 0;
				} else {
					return '';
				}
			},
			async getList() {
				await this.$store.dispatch('listContract/GET_HISTORICAL', this.$route.params.id);
			},
			getStatusClass(status) {
				if (status === 'On Going') {
					return 'badge bg-green align-items-center badge-lg';
				} else if (status === 'Closed') {
					return 'badge bg-red align-items-center badge-lg';
				} else if (status === 'Early Termination') {
					return 'badge bg-dark align-items-center badge-lg';
				} else if (status === 'Expired Soon') {
					return 'badge bg-yellow align-items-center badge-lg';
				} else if (status === 'Expired') {
					return 'badge bg-pink align-items-center badge-lg';
				} else if (status === 'Value Warning') {
					return 'badge bg-orange align-items-center badge-lg';
				} else if (status === 'Draft') {
					return 'badge bg-gray align-items-center badge-lg';
				}
			},
		},
	};
</script>

<style>
	.vsa-item__heading {
		width: 100%;
		height: 100%;
	}
	.vsa-item__heading,
	.vsa-item__trigger {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.vsa-item__trigger {
		margin: 0;
		padding: 0;
		color: inherit;
		font-family: inherit;
		font-size: 16px;
		line-height: 1.15;
		border-width: 0;
		background-color: transparent;
		background-image: none;
		overflow: visible;
		text-transform: none;
		flex: 1 1 auto;
		color: var(--vsa-text-color);
		transition: all 0.2s linear;
		padding: var(--vsa-heading-padding);
	}
	.vsa-item__trigger[role='button'] {
		cursor: pointer;
	}
	.vsa-item__trigger[type='button'],
	.vsa-item__trigger[type='reset'],
	.vsa-item__trigger[type='submit'] {
		-webkit-appearance: button;
	}
	.vsa-item__trigger:focus {
		outline: 1px dotted;
		outline: 5px auto -webkit-focus-ring-color;
	}
	.vsa-item__trigger::-moz-focus-inner,
	.vsa-item__trigger[type='button']::-moz-focus-inner,
	.vsa-item__trigger[type='reset']::-moz-focus-inner,
	.vsa-item__trigger[type='submit']::-moz-focus-inner {
		border-style: none;
		padding: 0;
	}
	.vsa-item__trigger:-moz-focusring,
	.vsa-item__trigger[type='button']:-moz-focusring,
	.vsa-item__trigger[type='reset']:-moz-focusring,
	.vsa-item__trigger[type='submit']:-moz-focusring {
		outline: 1px dotted ButtonText;
	}
	.vsa-item__trigger:focus,
	.vsa-item__trigger:hover {
		outline: none;
		background-color: var(--vsa-highlight-color);
		color: var(--vsa-bg-color);
	}
	.vsa-item__trigger__icon--is-default {
		width: 40px;
		height: 40px;
		transform: scale(var(--vsa-default-icon-size));
	}
	.vsa-item__trigger__icon--is-default:after,
	.vsa-item__trigger__icon--is-default:before {
		background-color: var(--vsa-text-color);
		content: '';
		height: 3px;
		position: absolute;
		top: 10px;
		transition: all 0.13333s ease-in-out;
		width: 30px;
	}
	.vsa-item__trigger__icon--is-default:before {
		left: 0;
		transform: rotate(45deg) translate3d(8px, 22px, 0);
		transform-origin: 100%;
	}
	.vsa-item__trigger__icon--is-default:after {
		transform: rotate(-45deg) translate3d(-8px, 22px, 0);
		right: 0;
		transform-origin: 0;
	}
	.vsa-item__trigger[aria-expanded='true'] .vsa-item__trigger__icon--is-default:before {
		transform: rotate(45deg) translate3d(14px, 14px, 0);
	}
	.vsa-item__trigger[aria-expanded='true'] .vsa-item__trigger__icon--is-default:after {
		transform: rotate(-45deg) translate3d(-14px, 14px, 0);
	}
	.vsa-item__trigger__icon {
		display: block;
		margin-left: auto;
		position: relative;
		transition: all 0.2s ease-in-out;
	}
	.vsa-item__trigger:focus .vsa-item__trigger__icon--is-default:after,
	.vsa-item__trigger:focus .vsa-item__trigger__icon--is-default:before,
	.vsa-item__trigger:hover .vsa-item__trigger__icon--is-default:after,
	.vsa-item__trigger:hover .vsa-item__trigger__icon--is-default:before {
		background-color: var(--vsa-bg-color);
	}
	.vsa-item__trigger__content {
		font-weight: 700;
		font-size: 14px !important;
	}
	.vsa-item__content {
		margin: 0;
		padding: 20px 20px;
	}
	.vsa-item--is-active .vsa-item__heading,
	.vsa-item:not(:last-of-type) {
		border-bottom: var(--vsa-border);
	}
	.vsa-collapse-enter-active,
	.vsa-collapse-leave-active {
		transition-property: opacity, height, padding-top, padding-bottom;
		transition-duration: 0.3s;
		transition-timing-function: ease-in-out;
	}
	.vsa-collapse-enter,
	.vsa-collapse-leave-active {
		opacity: 0;
		height: 0;
		padding-top: 0;
		padding-bottom: 0;
		overflow: hidden;
	}
	.vsa-list {
		--vsa-max-width: 720px;
		--vsa-min-width: 300px;
		--vsa-heading-padding: 10px 10px;
		--vsa-text-color: #373737;
		--vsa-highlight-color: #a12529;
		--vsa-bg-color: #fff;
		--vsa-border-color: rgba(0, 0, 0, 0.2);
		--vsa-border-width: 1px;
		--vsa-border-style: solid;
		--vsa-border: var(--vsa-border-width) var(--vsa-border-style) var(--vsa-border-color);
		--vsa-content-padding: 1rem 1rem;
		--vsa-default-icon-size: 1;
		display: block;
		max-width: var(--vsa-max-width);
		min-width: var(--vsa-min-width);
		width: 100%;
		padding: 0;
		margin: 0;
		list-style: none;
		border: var(--vsa-border);
		color: var(--vsa-text-color);
		background-color: var(--vsa-bg-color);
	}
	.vsa-list [hidden] {
		display: none;
	}
	.historical-log {
		padding: 20px;
	}
	.historical-log ul {
		list-style-type: none;
		padding: 0;
	}
	.historical-log li {
		margin-bottom: 15px;
		border: 1px solid #ccc;
		padding: 10px;
		border-radius: 5px;
	}
	.badge-lg {
		padding: 0.5rem 0.8rem !important;
		margin-bottom: 0px !important;
	}
	.badge.bg-green {
		background-color: #2ecc71;
	}

	.badge.bg-red {
		background-color: #ff0000;
	}

	.badge.bg-pink {
		background-color: #fd9596;
	}

	.badge.bg-dark {
		background-color: #333333;
	}

	.badge.bg-yellow {
		background-color: #f1c40f;
	}

	.badge.bg-orange {
		background-color: #e67e22;
	}

	.badge.bg-gray {
		background-color: #999999;
	}

	button .vsa-item__trigger {
		text-align: center !important;
	}
</style>
<style lang="scss" scoped>
	.vsa-item {
		&--is-active {
			.vsa-item__trigger__icon {
				.isOpen {
					display: none;
				}

				.isClose {
					display: block;
				}
			}
		}

		&__trigger__icon {
			.isOpen {
				display: block;
			}

			.isClose {
				display: none;
			}
		}
	}
</style>
